import { FC, useEffect, useState } from 'react';
import Rise from 'react-spinners/RiseLoader';
import Dot from 'react-spinners/DotLoader';
import Circle from 'react-spinners/CircleLoader';
import Ring from 'react-spinners/RingLoader';
import Scale from 'react-spinners/ScaleLoader';
import { orange } from '@mui/material/colors';
import { getRandom } from '../utilities/utils';

export enum LoaderType { rise, dot, circle, ring, scale }

interface LazyLoaderProps {
    delay?: number;
    loaderType?: LoaderType;
    status: string;
    ignoreTimeout?: boolean;
}

const LazyLoader: FC<LazyLoaderProps> = ({
    delay = 250, loaderType, status, ignoreTimeout = true,
}) => {
    const [show, setShow] = useState(false);
    let activeLoaderType = loaderType;
    if (loaderType === undefined) activeLoaderType = getRandom(0, 3) as LoaderType;
    useEffect(() => {
        const showTimeout = setTimeout(() => {
            setShow(true);
        }, delay);

        let timeout: NodeJS.Timeout;
        if (!ignoreTimeout) {
            timeout = setTimeout(() => {
                setShow(false);
            }, 20000); // after 20 seconds trying to show give up and show blank
        }
        return () => {
            clearTimeout(showTimeout);
            if (timeout) clearTimeout(timeout);
        };
    }, [delay, ignoreTimeout]);
    const size = 40;
    return show ? <div className='loaderOverlay'>
        {activeLoaderType === LoaderType.rise &&
            <Rise
                color={orange[200]}
                loading
                size={size}
            />
        }
        {activeLoaderType === LoaderType.circle &&
            <Circle
                color={orange[200]}
                loading
                size={size}
            />
        }
        {(activeLoaderType === undefined || activeLoaderType === LoaderType.dot) &&
            <Dot
                color={orange[200]}
                loading
                size={size}
            />
        }
        {activeLoaderType === LoaderType.ring &&
            <Ring
                color={orange[200]}
                loading
                size={size}
            />
        }
        {activeLoaderType === LoaderType.scale &&
            <Scale
                color={orange[200]}
                loading
                radius={size}
            />
        }
        <p className='white' style={{ zIndex: 2 }}>
            <span>{status}</span>
        </p>
    </div > : null;
};

export { LazyLoader as default };

